import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const hubRunnerService = {};

hubRunnerService.listHubRunner = (hub_id, time_slot_id) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/list-runner-hub/${hub_id}`,
    method: "get",
    params: {
      time_slot_id,
    },
  });
};

hubRunnerService.getRunnerCoordinationDefault = (
  hub_id,
  time_slot_id,
  action_date,
  province_code,
  district_code,
  ward_code
) => {
  return fetchV2({
    url: `${env.API_MSP}/runner-schedules/find-runner`,
    method: "post",
    data: {
      hub_id,
      timeslot_id: time_slot_id,
      action_date,
      province_code,
      district_code,
      ward_code,
    },
  });
};

export default hubRunnerService;
